import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EntertainmentCategory from '../entertainmentCategory/EntertainmentCategory';
import { entertainmentDetailsPage } from '../../utils';
import { virtualPageView } from '../../googleTagManager';
import '../entertainment/Entertainment.scss';
import WarningMessage from '../warningMessage/WarningMessage';
import Message from '../message/Message';

const getPageTitle = (isSummaryPage, title) => {
  if (isSummaryPage) return '';
  return title;
};

const Swimming = ({
  title = '',
  subTitle = '',
  splashEntertainments,
  resId = 0,
  siteCode = '',
  getAvailableEntertainments = () => { },
  shouldFetchBookedEntertainments = false,
  getBookedEntertainments = () => { },
  shouldFetchAvailableEntertainments,
  bookedEvents = [],
  detailPage = entertainmentDetailsPage,
  showSwimmingWarning = false,
  swimmingInterval,
  isSummaryPage,
  isAllowedToBookSwimming,
  swimmingFreeFlowMessage,
  shouldFetchBackstopDate,
  getBackstopDateFromApi,
}) => {
  useEffect(() => {
    virtualPageView('plan my day', 'book swimming', '/ga-virtual/plan-my-day/book-swimming');
  }, []);

  useEffect(() => {
    if (shouldFetchAvailableEntertainments) getAvailableEntertainments(siteCode);
  }, [
    shouldFetchAvailableEntertainments,
    getAvailableEntertainments,
    siteCode,
  ]);

  useEffect(() => {
    if (shouldFetchBookedEntertainments) getBookedEntertainments(resId, siteCode);
  }, [
    resId,
    siteCode,
    shouldFetchBookedEntertainments,
    getBookedEntertainments,
  ]);

  useEffect(() => {
    if (shouldFetchBackstopDate) getBackstopDateFromApi();
  }, [shouldFetchBackstopDate, getBackstopDateFromApi]);

  if (!isAllowedToBookSwimming && isSummaryPage) return null;
  if (splashEntertainments.length === 0 && isSummaryPage) return null;

  return (
    <div>
      <div className={classnames('entertainment-main-container', !isSummaryPage && 'notSummaryPage')}>
        <div className="titles">
          <div className="title">{getPageTitle(isSummaryPage, title)}</div>
          <div className="sub-title">{subTitle}</div>
          {showSwimmingWarning && (
            <WarningMessage
              message={`In line with current Government advice, 
                        we&apos;re limiting the number of guests in our pools at any one time.
                        You can pre-book a ${swimmingInterval}-minute session during your break.
                        You will also be able to book an additional slot each day on a first come, first served basis`}
            />
          )}
        </div>
        <div className={classnames('entertainments', showSwimmingWarning && 'show-warning', !isSummaryPage && 'notSummaryPage')}>
          {(splashEntertainments.map(({ date, events }, index) => (
            <EntertainmentCategory
              key={index}
              categoryIndex={index}
              date={date}
              events={events}
              bookedEvents={bookedEvents}
              detailPage={detailPage}
            />
          )))}
        </div>
        {!!swimmingFreeFlowMessage && <Message messages={[swimmingFreeFlowMessage]} />}
      </div>
    </div>
  );
};

Swimming.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  splashEntertainments: PropTypes.array,
  resId: PropTypes.number,
  siteCode: PropTypes.string,
  getAvailableEntertainments: PropTypes.func,
  shouldFetchBookedEntertainments: PropTypes.bool,
  getBookedEntertainments: PropTypes.func,
  shouldFetchAvailableEntertainments: PropTypes.bool,
  bookedEvents: PropTypes.array,
  detailPage: PropTypes.string,
  showSwimmingWarning: PropTypes.bool,
  swimmingInterval: PropTypes.number,
  isSummaryPage: PropTypes.bool,
  isAllowedToBookSwimming: PropTypes.bool,
  swimmingFreeFlowMessage: PropTypes.string,
  shouldFetchBackstopDate: PropTypes.bool,
  getBackstopDateFromApi: PropTypes.func,
};

export default Swimming;
